import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import _ from 'lodash';
import NumberFormat from 'react-number-format';
import UpdatedDashboard from "./UpdatedDashboard";
import {Doughnut, Line} from 'react-chartjs-2';
import 'chart.piecelabel.js';
import {toast} from 'react-toastify';
import {getPermission, getUser} from '../../utils/TokenManager';
import {AGENCY_REVENUE_GOAL, REVENUE_GOAL} from "../common/Constants";
import * as AgencyRevenueAction from "../../actions/AgencyRevenueAction";
import AgencyRevenueService from "../../services/AgencyRevenueService";
import RevenueGoal from "./RevenueGoal";
import OverrideRevenueGoal from "./OverrideRevenueGoal";
import ErrorMsg from "../common/ErrorMsg";
import LoadingModal from "../common/LoadingModal";
import * as SaveStateAction from '../../actions/SaveStateAction';
import {agencyTrendData, lineChartOptions} from '../common/LineGraph';


const options = {
    maintainAspectRatio: true,
    responsive: true,
	legend: {
		display: false,
		position: "top",
		labels: {
			fontSize: 10,
		}
    },
    pieceLabel: {
        render: 'label',
        fontSize: 11,
        fontStyle: 'bold',
        fontColor: '#000',
        arc: true
    },
    plugins: {
        datalabels: {
            display: false
        }
    }
}

const revenueActualPiChart = {
    labels: [
        'TY Actual Till Date',
        'LY Actual Till Date'
    ],
    datasets: [{
        data: [300, 50],
        backgroundColor: [
            '#84be44',
            '#645ea4'
        ],
        hoverBackgroundColor: [
            '#84be44',
            '#645ea4'
        ]
    }]
};

const revenueGoalPiChart = {
    labels: [
        'TY Actual Till Date',
        'TY Goal Till Date'
    ],
    datasets: [{
        data: [300, 50],
        backgroundColor: [
            '#84be44',
            '#645ea4'
        ],
        hoverBackgroundColor: [
            '#84be44',
            '#645ea4'
        ]
    }]
};

const compensationActualPiChart = {
    labels: [
        'LY Comp Paid',
        'LY Actual Total'
    ],
    datasets: [{
        data: [300, 50],
        backgroundColor: [
            '#84be44',
            '#645ea4'
        ],
        hoverBackgroundColor: [
            '#84be44',
            '#645ea4'
        ]
    }]
};

const compensationGoalPiChart = {
    labels: [
        'TY Comp Planned',
        'TY Goal Total'
    ],
    datasets: [{
        data: [300, 50],
        backgroundColor: [
            '#84be44',
            '#645ea4'
        ],
        hoverBackgroundColor: [
            '#84be44',
            '#645ea4'
        ]
    }]
};

class MainDashboard extends Component {
    state = {
        plListProfile: this.props.defaultAgencyProfile.profileId,
        selectedPlListObject: this.props.defaultAgencyProfile.profile,
        plList: this.props.plList.plList,
        showRevenueDashboard: false || this.props.iw,
        showRevenueGoal: false,
        showMainDashboard: true && !this.props.iw,
        showDashboardPage: true,
        showOverrideRevenueGoal: false,
        plProfile: {},
        totalLYRevenue: 0,
        totalTYRevenue: 0,
        revenues: [],
        revenueGoal: {},
        overridePlProfile: {},
        piChart: {},
        lineGraph: {},
        isRevenueChanged : false,
        isRevenueGoalChanged : false, 
        isRevenueGoalOverriden : false
    
    }

    auth = {
		user: getUser(),
        permission: getPermission()[AGENCY_REVENUE_GOAL]
	}

    componentDidMount = async () => {
        if (this.props.agencyLocation) {
            await this.getInitialState();
        }

        if (Object.keys(this.props.savedState).length > 0) {
            this.setState({...this.props.savedState});
            this.props.removeState();
        }
    };

    componentWillUnmount = () => {
        const { isRevenueChanged, isRevenueGoalOverriden, isRevenueGoalChanged } = this.state;
        if (isRevenueChanged || isRevenueGoalOverriden || isRevenueGoalChanged) {
            
            this.props.showConfirmModal({
                msgTitle: 'Save / Discard Changes !',
                msgBody: [
                    <p>There are some unsaved changes in Revenues.</p>,
                    <p>Do you want to save / discard the changes ?</p>
                ],
                buttons: [
                    {
                        label : 'Save',
                        onClick : () => {
                            if (isRevenueChanged) {
                                this.saveRevenue();
                            }

                            if (isRevenueGoalOverriden) {
                                this.saveOverrideRevenueGoal();
                            }

                            if (isRevenueGoalChanged) {
                                this.saveRevenueGoal();
                            }
                        },
                        className : 'btn-success'
                    },
                    {
                        label : 'Discard',
                        onClick : () => {},
                        className : 'btn-danger'
                    },
                    {
                        label : 'Cancel',
                        onClick : () => {
                            this.props.saveState(Object.assign({}, this.state));
                            if(this.props.iw) {
                                this.props.openPrevModule();
                            } else {
                                this.props.history.push('/home#revenue');
                            }
                        },
                        className : 'btn-primary'
                    }
                ]
            });
        }
    };

    getInitialState = async () => {
        if (this.auth.permission.can_view) {
            try {
                if (this.props.defaultAgencyProfile) {
                    await this.props.getInitialData(
                        this.props.agencyLocation, this.props.defaultAgencyProfile.profileId
                    );
                } else {
                    await this.props.getInitialData(this.props.agencyLocation, "");
                }
                
                this.setState({
                    plList: this.props.plList.plList,
                    plListProfile: this.props.defaultAgencyProfile.profileId,
                    selectedPlListObject: this.props.defaultAgencyProfile.profile,
                    piChart: this.props.piChart
                }, () => {
                    if (this.props.iw) {
                        this.getUpdatedDashboardData();
                    }
                })
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    showDashboard = () => {
        let dashboardElement = document.getElementById("main-dashboard-tab");
        dashboardElement.classList.add('active');
        let trendElement = document.getElementById("agency-trend-tab");
        trendElement.classList.remove('active');

        this.setState({showDashboardPage: true});
    };

    showAgencyTrend = async () => {
        let trendElement = document.getElementById("agency-trend-tab");
        trendElement.classList.add('active');
        let dashboardElement = document.getElementById("main-dashboard-tab");
        dashboardElement.classList.remove('active');
        const {plListProfile} = this.state;
        if (plListProfile && plListProfile > 0) {    
            try {
                await this.props.getLineGraph(plListProfile);
                this.setState({
                    lineGraph: this.props.lineGraph,
                    showDashboardPage: false
                })
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        } else {
            toast.error("Please select agency profile (P&L Profile).")
        }
    };

    getSelectedPlList = (event) => {
        if (event.currentTarget.value === "") {
            return false;
        }

        this.setState({plListProfile: event.currentTarget.value},
            () => this.getSelectedPlListData());
    };

    getSelectedPlListData = async () => {
        const {plListProfile, plList} = this.state;

        let selectedAgencyProfile = {};
        plList.map(profile => {
            if (profile.id === parseInt(plListProfile)) {
                selectedAgencyProfile = {...profile};
            }
        });

        // set newly selected agency profile as default
        this.props.setDefaultAgencyProfile(plListProfile, selectedAgencyProfile);
        if (!this.state.showOverrideRevenueGoal){
            try {
                let result = await AgencyRevenueService.piChart(plListProfile);
                await this.props.getLineGraph(plListProfile);

                if(this.state.showRevenueDashboard) {
                    this.setState({
                        piChart: result.data.pl_profile,
                        lineGraph: this.props.lineGraph
                    }, () => this.getUpdatedDashboardData());
                } else {
                    this.setState({
                        showRevenueGoal: false,
                        showRevenueDashboard: false,
                        showMainDashboard: true,
                        showOverrideRevenueGoal: false,
                        piChart: result.data.pl_profile,
                        lineGraph: this.props.lineGraph
                    });
                }
            } catch (error) {
                console.log("getSelectedPlListData", error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
        else{
            this.getOverrideGoal()
        }
    };

    handleStartEndDateChange = (startDate, endDate) => {
        let newPlProfile = {};
        newPlProfile['start_date'] = startDate;
        newPlProfile['end_date'] = endDate;

        this.setState({
            plProfile: newPlProfile
        });
    };

    handleDateChange = (date, field) => {
        let newPlProfile = {...this.state.plProfile};
        if (field === "start_date") {
            newPlProfile['start_date'] = date;
        } else {
            newPlProfile['end_date'] = date;
        }

        this.setState({plProfile: newPlProfile});
    };

    savePlProfile = async (enableAddButton) => {
        if (this.auth.permission.can_add || this.auth.permission.can_edit) {
            const {plListProfile, plProfile} = this.state;
            
            let newPlProfile = {
                "agency_location": this.props.agencyLocation,
                "start_date": this.state.plProfile.start_date,
                "end_date": this.state.plProfile.end_date
            };
            let isNewPl = false;
            this.setState({isLoading: true});
            try {
                if (enableAddButton) {
                    isNewPl = true;
                    await this.props.saveRevenuePlProfile(0, newPlProfile);
                } else {
                    if (plListProfile) {
                        await this.props.saveRevenuePlProfile(plListProfile, plProfile);
                    } else {
                        return false;
                    }
                }
                this.updatePlProfileList(isNewPl, this.props.revenueProfile.revenueProfile);
                this.setState({
                    plProfile: this.props.revenueProfile.revenueProfile,
                    revenue: this.props.revenueProfile.revenueProfile.revenues
                }, () => this.calculateRevenue());

                toast.success("Saved Successfully.");
            } catch (error) {
                console.log("savePlProfile", error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 8000});
            }
            this.setState({isLoading: false});
        }
    };

    updatePlProfileList = (isNewPl, list) => {
        let data = {
            id: list.id,
            agency_location: list.agency_location,
            profile: list.profile,
            is_default: true
        };
        let newPlList = [];
        if (isNewPl) {
            newPlList = [...this.state.plList, data];

        } else {
            newPlList = this.state.plList.map((list) => {
                if (parseInt(list.id, 10) === parseInt(data.id, 10)) {
                    return {...data};
                }
                return list;
            });
        }

        this.setState({
            plList: newPlList,
            plListProfile: list.id
        }, () => this.getSelectedPlListData());
    };

    cancelPlListChange = () => {
        this.setState({
            plProfile: this.props.revenueProfile.revenueProfile
        });
    };

    getUpdatedDashboardData = async () => {
        if (this.auth.permission.can_view) {
            const {plListProfile} = this.state;

            try {
                if (plListProfile > 0) {
                    await this.props.getRevenuePlProfile(plListProfile);

                    this.setState({
                        showRevenueGoal: false,
                        showRevenueDashboard: true,
                        showMainDashboard: false,
                        showOverrideRevenueGoal: false,
                        plProfile: this.props.revenueProfile.revenueProfile,
                        revenue: this.props.revenueProfile.revenueProfile.revenues
                    }, () => this.calculateRevenue());
                } else {
                    this.setState({
                        showRevenueGoal: false,
                        showRevenueDashboard: true,
                        showMainDashboard: false,
                        showOverrideRevenueGoal: false
                    })
                }

            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    handleRevenueChange = (className, value) => {
        const {revenues, plProfile} = this.state;
        let changedRow = plProfile.revenues.filter((revenue) =>
            parseInt(revenue.id, 10) === parseInt(className[1], 10));
        changedRow = Object.assign({}, changedRow[0]);
        if(isNaN(value)) {
            value = 0;
        } 

        switch (className[0]) {
            case 'newrevenue':
                changedRow.new_revenue = value;
                break;
            case 'revenue':
                changedRow.renewal_revenue = value;
                break;
            case 'combined':
                changedRow.renewal_revenue = value;
                changedRow.combined_revenue = value;
                break;
            case 'lyrevenue':
                changedRow.last_year_revenue = value;
                break;
            default:
                break;
        }

        const newRevenue = revenues.map((revenue) => {
            if (parseInt(revenue.id, 10) === parseInt(className[1], 10)) {
                return changedRow;
            }

            return revenue;
        });

        let newPlProfile = Object.assign({}, plProfile);
        newPlProfile = Object.assign({}, newPlProfile, {revenues: newRevenue});

        this.setState({
            plProfile: newPlProfile, 
            revenues: newRevenue, 
            isRevenueChanged : true
        }, () => {this.calculateRevenue()});
    };

    calculateRevenue = () => {
        const plProfile = Object.assign({}, this.state.plProfile);
        let totalLYRevenue = 0, totalTYRevenue = 0;

        let newRevenue = plProfile.revenues.map((revenue) => {
            revenue.combined_revenue = parseInt(revenue.new_revenue) +
                parseInt(revenue.renewal_revenue);
            totalTYRevenue += parseInt(revenue.combined_revenue);
            totalLYRevenue += parseInt(revenue.last_year_revenue);
            return revenue;
        });

        let newPlProfile = Object.assign({}, plProfile, {revenues: newRevenue});

        this.setState({
            plProfile: newPlProfile,
            totalLYRevenue: totalLYRevenue,
            totalTYRevenue: totalTYRevenue,
            revenues: newRevenue
        });
    };

    combinedRevenue = () => {
        const plProfile = Object.assign({}, this.state.plProfile);
        let newRevenue = plProfile.revenues.map((revenue) => {
            revenue.renewal_revenue = parseInt(revenue.renewal_revenue) +
                parseInt(revenue.new_revenue);
            revenue.new_revenue = 0;
            return revenue;
        });

        let newPlProfile = Object.assign({}, plProfile, {revenues: newRevenue});

        this.setState({plProfile: newPlProfile, revenues: newRevenue});
    };

    updateCombinedRevenue = async () => {
        if (this.auth.permission.can_add || this.auth.permission.can_edit) {
            const {plProfile, plListProfile} = this.state;
            if (typeof plProfile.revenues !== "undefined" && plProfile.revenues.length) {
                let newPlProfile = Object.assign({}, this.state.plProfile);
                newPlProfile.combine_new_renewal = !newPlProfile.combine_new_renewal;

                try {
                    let data = {
                        combine_new_renewal: newPlProfile.combine_new_renewal
                    };
                    await AgencyRevenueService.saveCombined(data, plListProfile);
                    this.setState({plProfile: newPlProfile});

                    if (newPlProfile.combine_new_renewal) {
                        this.combinedRevenue();
                    }
                } catch (error) {
                    toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
                }
            }
        }
    };

    saveRevenue = async (showMsg) => {
        if (this.auth.permission.can_add || this.auth.permission.can_edit) {
            try {
                let result = await this.props.saveRevenue(
                    this.state.revenues, this.state.plListProfile
                );

                if (result) {
                    const plProfile = Object.assign({}, this.state.plProfile);
                    const newPlProfile = Object.assign({}, plProfile, {revenues: this.props.revenue.revenue});
                    this.setState({
                        plProfile: newPlProfile, 
                        revenues: this.props.revenue.revenue, 
                        isRevenueChanged : false
                    });
                    if (showMsg){
                        toast.success("saved successfully");
                    }
                    if (this.props.iw) {
                        this.props.autocompleteModule();
                    }
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    cancelRevenueChanges = () => {
        this.setState({revenues: this.props.revenue.revenue});
    };

    getRevenueGoalInitialData = async () => {
        if (this.auth.permission.can_view) {
            try {
                if (this.state.plListProfile) {
                    let result = await this.props.getRevenueGoal(this.state.plListProfile);

                    if (result) {
                        this.setState({
                            revenueGoal: this.props.revenueGoal,
                            showRevenueGoal: true,
                            showRevenueDashboard: false,
                            showMainDashboard: false,
                            showOverrideRevenueGoal: false
                        }, () => this.calculateRevenueGoal());
                    }
                } else {
                    toast.error("Please select P&L Profile.");
                }
            } catch (error) {
                console.log("getRevenueGoalInitialData", error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    calculateRevenueGoal = () => {
        const {revenueGoal} = this.state;
        let newRevenueGoal = Object.assign({}, revenueGoal);

        newRevenueGoal.total_revenue_goal =
            parseInt(newRevenueGoal.new_revenue_goal) + parseInt(newRevenueGoal.renewal_revenue_goal);
        newRevenueGoal.monthly_goal =
            Math.round(parseInt(newRevenueGoal.total_revenue_goal) / parseInt(newRevenueGoal.no_of_months));
        newRevenueGoal.new_revenue_goal_per =
            (parseInt(newRevenueGoal.new_revenue_goal) / parseInt(newRevenueGoal.total_revenue_goal)) * 100;
        newRevenueGoal.renewal_revenue_goal_per =
            (parseInt(newRevenueGoal.renewal_revenue_goal) / parseInt(newRevenueGoal.total_revenue_goal)) * 100;

        newRevenueGoal.new_revenue_goal_per = Math.round(newRevenueGoal.new_revenue_goal_per);
        newRevenueGoal.renewal_revenue_goal_per = Math.round(newRevenueGoal.renewal_revenue_goal_per);
        this.setState({revenueGoal: newRevenueGoal});
    };

    handleRevenueGoalChanges = (className, value) => {
        const {revenueGoal} = this.state;
        let newRevenueGoal = Object.assign({}, revenueGoal);
        if(isNaN(value)) {
            value = 0;
        } 
        switch (className) {
            case 'new_revenue_goal':
                newRevenueGoal.new_revenue_goal = value;
                break;
            case 'renewal_revenue_goal':
                newRevenueGoal.renewal_revenue_goal = value;
                break;
            default:
                break;
        }

        this.setState({revenueGoal: newRevenueGoal, isRevenueGoalChanged : true}, () => this.calculateRevenueGoal());
    };

    saveRevenueGoal = async () => {
        if (this.auth.permission.can_edit || this.auth.permission.can_add) {
            const {plListProfile, revenueGoal} = this.state;

            try {
                let result = await this.props.saveRevenueGoal(revenueGoal, plListProfile);

                if (result) {
                    this.setState({isRevenueGoalChanged : false});
                    toast.success("Saved Successfully.");
                }
            } catch (error) {
                console.log("saveRevenueGoal", error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    cancelRevenueGoalChanges = () => {
        this.setState({revenueGoal: this.props.revenueGoal});
    };

    getOverrideGoal = async () => {
        this.setState({showOverrideRevenueGoal: false});
        if (this.auth.permission.can_view) {
            try {
                if (this.state.plListProfile){
                    let result = await this.props.getOverrideRevenueGoal(
                        this.state.plListProfile
                    );

                    if (result) {
                        this.setState({
                            overridePlProfile: {...this.props.overrideRevenueGoal},
                            showRevenueGoal: false,
                            showRevenueDashboard: false,
                            showMainDashboard: false,
                            showOverrideRevenueGoal: true
                        });
                    }
                } else {
                    toast.error("Please select P&L Profile.");
                }
            } catch (error) {
                console.log("getOverrideGoal", error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    handleOverrideRevenueGoalChanges = (className, value) => {
        const {overridePlProfile} = this.state;
        let changedRow = overridePlProfile.revenue_goals.filter((revenue) =>
            parseInt(revenue.id, 10) === parseInt(className[1], 10));
        changedRow = Object.assign({}, changedRow[0]);
        if(isNaN(value)) {
            value = 0;
        } 
        switch (className[0]) {
            case 'new_goal':
                changedRow.new_goal = value;
                break;
            case 'updated_new_goal':
                changedRow.updated_new_goal = value;
                break;
            case 'renewal_goal':
                changedRow.renewal_goal = value;
                break;
            case 'combined_goal':
                changedRow.renewal_goal = value;
                changedRow.combined_goal = value;
                break;
            default:
                break;
        }

        let newOverrideRevenueGoal = overridePlProfile.revenue_goals.map((revenue) => {
            if (parseInt(revenue.id, 10) === parseInt(className[1], 10)) {
                return changedRow;
            }
            return revenue;
        });

        let newOverridePlProfile = Object.assign({}, overridePlProfile);
        newOverridePlProfile =
            Object.assign({}, newOverridePlProfile, {revenue_goals: newOverrideRevenueGoal});
        this.setState({
            overridePlProfile: newOverridePlProfile,
            isRevenueGoalOverriden : true
        }, () => this.calculateOverrideRevenueGoal(className[0]));
    };

    calculateOverrideRevenueGoal = (className) => {
        const overridePlProfile = Object.assign({}, this.state.overridePlProfile);
        let totalOverrideGoal = 0;

        let newOverrideRevenueGoal = overridePlProfile.revenue_goals.map((revenue) => {
            revenue.combined_goal = parseInt(revenue.new_goal) +
                parseInt(revenue.renewal_goal);
            totalOverrideGoal += parseInt(revenue.combined_goal);
            return revenue;
        });
        overridePlProfile.total_override_goal = totalOverrideGoal;
        let newOverridePlProfile =
            Object.assign({}, overridePlProfile, {revenue_goals: newOverrideRevenueGoal});

        this.setState({
            overridePlProfile: newOverridePlProfile
        });
    };

    updateOverrideGoal = async () => {
        if (this.auth.permission.can_edit || this.auth.permission.can_add) {
            const {overridePlProfile, plListProfile} = this.state;
            if (typeof overridePlProfile.revenue_goals != "undefined" && overridePlProfile.revenue_goals.length) {
                let newOverridePlProfile = Object.assign({}, overridePlProfile);
                newOverridePlProfile.override_calculate_goal = !newOverridePlProfile.override_calculate_goal;

                try {
                    let data = {
                        override_calculate_goal: newOverridePlProfile.override_calculate_goal
                    };
                    await AgencyRevenueService.saveCombined(data, plListProfile);
                    this.setState(
                        {overridePlProfile: newOverridePlProfile}, 
                    );
                } catch (error) {
                    console.log("updateOverrideGoal", error);
                    toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
                }
            }
        }
    };

    saveOverrideRevenueGoal = async (plannedIncrease, plannedRetention, showMsg=false) => {
        if (this.auth.permission.can_edit || this.auth.permission.can_add) {
            const {plListProfile, overridePlProfile} = this.state;
            let data = Object.assign({}, overridePlProfile);
            data.goal_increase = plannedIncrease;
            data.planned_retention = plannedRetention;

            try {
                const result = await this.props.saveOverrideRevenueGoal(data, plListProfile);
                if (result) {
                    if (showMsg){
                        toast.success("Saved Successfully.");
                    }
                    this.setState({
                        overridePlProfile: this.props.overrideRevenueGoal,
                        isRevenueGoalOverriden: false
                    });
                    if (this.props.iw) {
                        this.props.updatePLRevenueGoal();
                        this.props.autocompleteModule();
                    }
                }
            } catch (error) {
                console.log("saveOverrideRevenueGoal", error);
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    };

    cancelOverrideRevenueGoalChanges = () => {
        this.setState({overridePlProfile: this.props.overrideRevenueGoal});
    };

    backToDashboard = () => {
        const {plListProfile} = this.state;
        if (!plListProfile) {
            this.setState({
                showRevenueGoal: false,
                showRevenueDashboard: false,
                showMainDashboard: true,
                showOverrideRevenueGoal: false,
            });
        } else {
            this.setState({
                showMainDashboard: true,
                showRevenueDashboard: false,
            }, () => this.getSelectedPlListData());
        }
    };

    backToAdminDashboard = () => {
        this.setState({
            showRevenueDashboard: true,
            showRevenueGoal: false,
            showMainDashboard: false,
            showOverrideRevenueGoal: false,
        });
        this.getUpdatedDashboardData();
    };

    render = () => {
        let plListOption;
        const {
            plList, plProfile, plListProfile, totalLYRevenue, totalTYRevenue, 
            showDashboardPage, revenues, revenueGoal, showOverrideRevenueGoal, 
            overridePlProfile, piChart
        } = this.state;
        const {lineGraph} = this.props;

        if (typeof plList !== "undefined" && plList.length) {
            plListOption = plList.map((list, index) =>
                <option key={index} value={list.id}>{list.profile}</option>
            );

            if (!(_.isEmpty(piChart))) {
                if(piChart.ty_actual_till_date && piChart.ly_actual_till_date) {
                    revenueActualPiChart.datasets[0].data = [piChart.ty_actual_till_date,
                        piChart.ly_actual_till_date];
                } else {
                    revenueActualPiChart.datasets[0].data = [1, 1];
                }
                if(piChart.ty_actual_till_date && piChart.ty_goal_till_date) {
                    revenueGoalPiChart.datasets[0].data = [piChart.ty_actual_till_date,
                        piChart.ty_goal_till_date];
                } else {
                    revenueGoalPiChart.datasets[0].data = [1, 1];
                }
                if(piChart.ly_compensation_paid && piChart.ly_actual_total) {
                    compensationActualPiChart.datasets[0].data = [piChart.ly_compensation_paid,
                        piChart.ly_actual_total];
                } else {
                    compensationActualPiChart.datasets[0].data = [1, 1];
                }
                if(piChart.ty_compensation_planned && piChart.ty_goal_total) {
                    compensationGoalPiChart.datasets[0].data = [piChart.ty_compensation_planned,
                        piChart.ty_goal_total];
                } else {
                    compensationGoalPiChart.datasets[0].data = [1, 1];
                }
            }

            if (!(_.isEmpty(lineGraph))) {
                agencyTrendData.labels = lineGraph.month_list;
                agencyTrendData.datasets[0].data = lineGraph.goals;
                agencyTrendData.datasets[1].data = lineGraph.revenue_actual;
                agencyTrendData.datasets[2].data = lineGraph.last_year_revenues;
            }
        }

        return (
            this.auth.permission.can_view ?
            <React.Fragment>
                {this.state.isLoading && <LoadingModal modal={this.state.isLoading} />}
                {this.state.showMainDashboard && !this.props.iw ? 
                    <div className="tab-pane" id="profile" role="tabpanel">
                        <div className="row">
                            <div className="col-6">
                                <label className="bg-primary text-white py-1 px-2 font-16 width-300">
                                    <span className="float-left">Total Planned Revenue: </span>
                                    <span className="font-18 box-text-shadow float-right font-weight-bold">
                                        <NumberFormat value={piChart.ty_goal_total} 
                                            displayType={'text'} decimalScale={0} 
                                            thousandSeparator={true} prefix={'$ '} 
                                            className="font-18 box-text-shadow" 
                                        />
                                    </span>
                                </label>
                            </div>
                            <div className="col-6 text-right">
                                <label className="compensation-bg text-white py-1 px-2 font-16 width-300">
                                    <span className="float-left">
                                        Total Planned Compensation: 
                                    </span>
                                    <span className="font-18 box-text-shadow float-right font-weight-bold">
                                        <NumberFormat value={piChart.ty_compensation_planned} 
                                            displayType={'text'} decimalScale={0} 
                                            thousandSeparator={true} prefix={'$ '} 
                                            className="font-18 box-text-shadow" 
                                        />
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div className="w-block">
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item" onClick={this.showDashboard}>
                                    <a className="nav-link active" id="main-dashboard-tab" data-toggle="tab" role="tab">
                                        <span className="hidden-sm-up"></span>
                                        <span className="hidden-xs-down">Main Dashboard</span>
                                    </a>
                                </li>
                                <li className="nav-item" onClick={this.showAgencyTrend}>
                                    <a className="nav-link" id="agency-trend-tab" data-toggle="tab" role="tab">
                                        <span className="hidden-sm-up"></span>
                                        <span className="hidden-xs-down">Agency Trend</span>
                                    </a>
                                </li>
                            </ul>

                            <div className="tab-content border border-top-0 p-3 bg-white">
                            {showDashboardPage ?
                                <div className="tab-pane active p-3" id="maindashboard" role="tabpanel">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <h3 className="title-r text-center">Revenue</h3>
                                            <ul className="list001 pi-chart">
                                                <li className="text-center" id="pi-chart-1">
                                                    <div className="position-relative">
                                                        <Doughnut data={revenueActualPiChart} width={100} height={80}
                                                        options={options}/>
                                                        <span className={piChart.revenue_actual_per >= 0 ? "value-block pi-percentage" : "value-block pi-percentage text-danger"}><span id="pi-percentage-1">{piChart.revenue_actual_per}%</span>
                                                        </span>
                                                    </div>
                                                    <span className="value-block" id="pi-amount-1">
                                                        <NumberFormat value={piChart.ly_actual_till_date} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                                                    </span>
                                                    <p className="p1">% - This year vs Last year<br/>$ - Last year actual revenue</p>
                                                </li>
                                                <li className="text-center" id="pi-chart-2">
                                                    <div className="position-relative">
                                                        <Doughnut data= {revenueGoalPiChart} width={100} height={80} options={options}/>
                                                        <span
                                                        className={piChart.revenue_goal_per >= 0 ? "value-block pi-percentage" : "value-block pi-percentage text-danger"}><span id="pi-percentage-2">{piChart.revenue_goal_per}%</span>
                                                        </span>
                                                    </div>
                                                    <span className="value-block" id="pi-amount-2">
                                                    <NumberFormat value={piChart.ty_goal_till_date} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                                                    </span>
                                                    <p className="p1">% - This year vs Goal<br/>$ - YTD revenue Goal</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-sm-4 text-center">
                                            <p className="text-center">
                                                <button
                                                    onClick={this.getUpdatedDashboardData}
                                                    className="btn text-center home-bg text-white">
                                                    Click here to Update Agency Revenue
                                                </button>
                                            </p>
                                            <br/>
                                            <span className="value-block bold-01">
                                                <span className=" p-2 px-3 border">
                                                <NumberFormat value={piChart.ty_actual_till_date | 0} displayType={'text'} thousandSeparator={true} prefix={'$ '} /></span>
                                            </span>
                                            <p className="text-center mt-2">YTD Revenue</p>
                                            <div className="date-block border-0">
                                                <div className="form-group">
                                                    <select name="plList"
                                                        className="form-control"
                                                        onChange={this.getSelectedPlList}
                                                        value={this.state.plListProfile}>
                                                        <option value="">Select P&L Profile</option>
                                                        {plListOption}
                                                    </select>
                                                </div>
                                            </div>
                                            {!(_.isEmpty(this.props.defaultAgencyProfile.profile)) && this.props.defaultAgencyProfile.profile.is_default ? '' :
                                                <p className="text-center text-danger">The selected profile range is not for the current profile period.</p>
                                            }
                                            
                                        </div>
                                        <div className="col-sm-4">
                                            <h3 className="title-r text-center">Compensation</h3>
                                            <ul className="list001 pi-chart" id="pi-chart-3">
                                                <li className="text-center">
                                                    <div className="position-relative">
                                                        <Doughnut data={compensationActualPiChart} width={100} height={80} options={options}/>
                                                        <span className={piChart.compensation_actual_per >= 0 ? "value-block pi-percentage" : "value-block pi-percentage text-danger"}><span id="pi-percentage-3">{piChart.compensation_actual_per}%</span>
                                                        </span>
                                                    </div>
                                                    <span className="value-block" id="pi-amount-3">
                                                    <NumberFormat value={piChart.ly_compensation_paid} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                                                    </span>
                                                    <p id="p3">% - LY Comp vs Revenue<br/>$ - Total LY Compensation</p>
                                                </li>
                                                <li className="text-center" id="pi-chart-4">
                                                    <div className="position-relative">
                                                        <Doughnut data={compensationGoalPiChart} width={100} height={80} options={options}/>
                                                        <span
                                                        className={piChart.compensation_goal_per >= 0 ? "value-block pi-percentage" : "value-block pi-percentage text-danger"}><span id="pi-percentage-4">{piChart.compensation_goal_per}%</span>
                                                        </span>
                                                    </div>
                                                    <span className="value-block" id="pi-amount-4">
                                                    <NumberFormat value={piChart.ty_compensation_planned} displayType={'text'} thousandSeparator={true} prefix={'$ '} />
                                                    </span>
                                                    <p id="p4">% - TY Comp vs Revenue<br/>$ - TY Planned Compensation</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="tab-pane p-3 active" id="agencytrend" role="tabpanel">
                                    <Line data={agencyTrendData} height={50} options={lineChartOptions}/>
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                    : null
                }
                {this.state.showRevenueDashboard && 
                    <UpdatedDashboard {...this.props} 
                        plProfile={plProfile}
                        plList={plList}
                        plListProfile={plListProfile}
                        totalLYRevenue={totalLYRevenue}
                        totalTYRevenue={totalTYRevenue}
                        revenues={revenues}
                        updateCombinedRevenue={this.updateCombinedRevenue}
                        backToDashboard={this.backToDashboard}
                        getRevenueGoal={this.getRevenueGoalInitialData}
                        getOverrideGoal={this.getOverrideGoal}
                        getLYCompensation={this.getLYCompensation}
                        saveRevenue={() => this.saveRevenue(true)}
                        cancelRevenueChanges={this.cancelRevenueChanges}
                        savePlProfile={this.savePlProfile}
                        combinedRevenue={this.combinedRevenue}
                        cancelPlListChange={this.cancelPlListChange}
                        getSelectedPlList={(event) => this.getSelectedPlList(event)}
                        handleRevenueChange={(className, value) =>
                            this.handleRevenueChange(className, value)}
                        handleDateChange={(date, field) =>
                            this.handleDateChange(date, field)}
                        handleStartEndDateChange={this.handleStartEndDateChange}
                        showConfirmModal = {this.props.showConfirmModal}
                        permission={this.auth.permission}
                    />
                }
                {this.state.showRevenueGoal &&
                    <RevenueGoal {...this.props} 
                        plProfile={plProfile}
                        revenueGoal={revenueGoal}
                        overridePlProfile={overridePlProfile}
                        backToDashboard={this.backToAdminDashboard}
                        saveRevenueGoal={this.saveRevenueGoal}
                        cancelRevenueGoalChanges={this.cancelRevenueGoalChanges}
                        handleRevenueGoalChanges={(className, value) =>
                            this.handleRevenueGoalChanges(className, value)
                        }
                        permission={this.auth.permission}
                    />
                }
                {showOverrideRevenueGoal && 
                    <OverrideRevenueGoal {...this.props} 
                        plProfile={plProfile}
                        totalLYRevenue={totalLYRevenue}
                        overridePlProfile={overridePlProfile}
                        backToDashboard={this.backToAdminDashboard}
                        updateOverrideGoal={this.updateOverrideGoal}
                        saveOverrideRevenueGoal={this.saveOverrideRevenueGoal}
                        getOverrideGoal={this.getOverrideGoal}
                        getSelectedPlList={(event) => this.getSelectedPlList(event)}
                        plListProfile={plListProfile}
                        cancelOverrideRevenueGoalChanges={this.cancelOverrideRevenueGoalChanges}
                        handleOverrideRevenueGoalChanges={(className, value) =>
                            this.handleOverrideRevenueGoalChanges(className, value)
                        }
                        permission={this.auth.permission}
                    />
                }
            </React.Fragment>
            : <div className="tab-pane text-center" role="tabpanel">
                Access Denied
            </div>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        defaultAgencyProfile: state.DefaultAgencyProfileReducer,
        plList: state.PlListReducer,
        piChart: state.PiChartReducer,
        agencyLocation: state.AgencyLocationReducer,
        revenueProfile: state.RevenueProfileReducer,
        revenue: state.AgencyRevenueReducer,
        revenueGoal: state.RevenueGoalReducer,
        overrideRevenueGoal: state.OverrideRevenueGoalReducer,
        lineGraph: state.LineGraphReducer,
        savedState : state.SaveStateReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({...AgencyRevenueAction, ...SaveStateAction}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(MainDashboard);



// WEBPACK FOOTER //
// ./src/components/agencyRevenue/MainDashboard.js